import React, {
  useState, useRef, useEffect, useContext,
} from 'react';
// import { useFetchye } from 'fetchye';
import uuid from 'react-uuid';
import {
  ButtonPrimary,
  ButtonSecondary,
  ButtonTertiary,
  DataTableV2,
  DataTableHeadV2,
  DataTableBodyV2,
  DataTableRowV2,
  DataTableHeadCellV2,
  DataTableCellV2,
  Select,
  SelectOption,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  parseHtml, getUniqueFileId, validFileFormat, validFileName, encryptPayload,
} from '../../utils/util';
import { ChildContext } from '../context';
import useManageButtonStates from '../../CustomHooks/useManageButtonState';

const getVal = require('lodash/get');

/**
 * returns DLS input component
 * @param {*} props
 */
/* eslint complexity: ["error", 51] -- need to increase complexity */
const PayloadFileAttachment = ({
  responseMessage,
  cssProperties,
  fieldValidation,
  fieldLabel,
  filesToAttach,
  fieldId,
  setFilesToAttach,
  entityToEdit,
  s3FileInfo,
  setS3FileInfo,
  filledFormData,
  isS3Upload = false,
  idGenField,
  formPageType,
  allS3FileIds,
  setAllS3FileIds,
  disabledButtons,
  setDisabledButtons,
  buttonsToDisable = [],
  tableDynamicProperties = null,
  selectFileTypeProps = null,
  loggerApiCall,
}) => {
  const contextVal = useContext(ChildContext);
  const memberApiUrls = useSelector((state) => state.getIn(['config', 'memberApiUrls']));
  const [fileData, setFileData] = useState(null);
  const [uploadResponse, setUploadResponse] = useState([]);
  const inputRef = useRef(null);
  const [validationMsg, setValidationMsg] = useState('');
  const inputDls = cssProperties.inputStyle ? cssProperties.inputStyle : 'col-md-5 col-md-offset-1 margin-1-t margin-2-b';
  const uploadButtonDls = cssProperties.uploadButtonStyle ? cssProperties.uploadButtonStyle : 'col-md-4 col-md-offset-1 margin-1-t';
  const tableDls = cssProperties.tableStyle ? cssProperties.tableStyle : 'col-md-10 col-md-offset-1';
  const errorBlockCss = cssProperties.errorBlockCss ? cssProperties.errorBlockCss : 'col-md-10 col-md-offset-1';
  const errorCss = cssProperties.errorBlockCss ? cssProperties.errorBlockCss : 'text-align-center dls-red';
  const fileSizeLimit = fieldValidation && fieldValidation.fileSizeLimit >= 0
    ? fieldValidation.fileSizeLimit : 10;
  const totalFileSizeLimit = fieldValidation && fieldValidation.totalFileSizeLimit >= 0
    ? fieldValidation.totalFileSizeLimit : 30;
  const allowedNumberOfFiles = fieldValidation && fieldValidation.allowedNumberOfFiles
    ? fieldValidation.allowedNumberOfFiles : 5;
  const [totalFileSz, setTotalFileSz] = useState(0);
  const uploadButtonLabel = fieldLabel && fieldLabel.uploadButtonLabel ? fieldLabel.uploadButtonLabel : 'Upload';
  const removeDocButtonLabel = fieldLabel && fieldLabel.removeDocButtonLabel ? fieldLabel.removeDocButtonLabel : 'Remove';
  const tableDocNameHeader = fieldLabel && fieldLabel.tableDocNameHeader ? fieldLabel.tableDocNameHeader : 'Document Name';
  const tableDocStatusHeader = fieldLabel && fieldLabel.tableDocStatusHeader ? fieldLabel.tableDocStatusHeader : 'Description of status';
  const tableDocRemoveHeader = fieldLabel && fieldLabel.tableDocRemoveHeader ? fieldLabel.tableDocRemoveHeader : 'To remove';
  const chooseFileButton = fieldLabel && fieldLabel.chooseFileButton ? fieldLabel.chooseFileButton : 'Choose file';
  const hideFileInput = fieldValidation && fieldValidation.hideFileInput
    ? fieldValidation.hideFileInput : false;
  const totalFileUploadText = fieldValidation && fieldValidation.totalFileUploadText
    ? fieldValidation.totalFileUploadText : 'Total files uploaded can be equal or less than';
  const fileSizeLimitError = fieldValidation && fieldValidation.fileSizeLimitError
    ? fieldValidation.fileSizeLimitError : 'File size can not exceed fileSizeLimit MB per file (totalFileSizeLimit MB in total)';
  const fileInputButton = document.querySelector(`#${fieldId}chooseFileButton`);
  const fileSizeError = fileSizeLimitError.replace('fileSizeLimit', fileSizeLimit).replace('totalFileSizeLimit', totalFileSizeLimit);
  const [isUploadInProgress, setIsUploadInProgress] = useState(false);
  const [removeFileId, setRemoveFileId] = useState(null);
  const [uploadedFileType, setUploadedFileType] = useState('');
  const [uploadedFileTypeLabel, setUploadedFileTypeLabel] = useState('');
  const [selectFileTypeErrorMsg, setSelectFileTypeErrorMsg] = useState('');

  useManageButtonStates({
    uploadResponse,
    buttonsToDisable,
    disabledButtons,
    fieldId,
    setDisabledButtons,
    minimumRequiredUploads: fieldValidation?.minimumRequiredUploads,
  });

  const validationMessages = (type) => {
    switch (type) {
      case 'totalFileLength':
        if (fieldValidation && fieldValidation.numberOfFilesErrorMsg) {
          return fieldValidation.numberOfFilesErrorMsg;
        }
        return `${totalFileUploadText} ${allowedNumberOfFiles}.`;
      case 'fileSizeExceed':
        if (fieldValidation && fieldValidation.fileSizeLimitErrorMsg) {
          return fieldValidation.fileSizeLimitErrorMsg;
        }
        return `${fileSizeError}`;
      case 'totalFileSizeExceed':
        if (fieldValidation && fieldValidation.totalFileSizeExceedErrorMsg) {
          return fieldValidation.totalFileSizeExceedErrorMsg;
        }
        return `${fileSizeError}`;
      case 'fileuploadFailure':
        return fieldValidation?.fileuploadFailureMsg || 'Failed to upload the file, please try again.';
      case 'formatErrorMsg':
        return fieldValidation?.formatErrorMsg || 'Invalid file format!';
      case 'specialCharErrorMsg':
        return fieldValidation?.specialCharErrorMsg || 'File name should not contain special characters.';
      default:
        return null;
    }
  };

  const convertFileSizeToMB = (fileSizeBytes) => {
    let fileSizeMB = fileSizeBytes / 1e6;
    fileSizeMB = Math.trunc(fileSizeMB * 10000) / 10000;
    return fileSizeMB;
  };

  /* eslint-disable max-len -- need */
  const validateFile = (data = null) => {
    if (data || (inputRef && inputRef.current && inputRef.current.files && inputRef.current.files.length > 0)) {
      const file = data || inputRef.current.files[0];
      setFileData('');
      const fileName = file.name;
      const fileSize = file.size;
      const calculatedFileSize = convertFileSizeToMB(totalFileSz) + convertFileSizeToMB(fileSize);

      if (fileInputButton) {
        fileInputButton.innerHTML = `${fileName}`;
      }

      if (!(uploadResponse.length >= allowedNumberOfFiles)) {
        // pass the file name through validation method
        if (!validFileFormat(fileName, fieldValidation?.allowedFormats)) {
          setValidationMsg(validationMessages('formatErrorMsg'));
        } else if (!validFileName(fileName, fieldValidation?.validFileNameRegex)) {
          setValidationMsg(validationMessages('specialCharErrorMsg'));
        } else if (convertFileSizeToMB(fileSize) > fileSizeLimit) {
          setValidationMsg(validationMessages('fileSizeExceed'));
        } else if (calculatedFileSize > totalFileSizeLimit) {
          if (fieldValidation && fieldValidation.totalFileSizeExceedErrorMsg) {
            setValidationMsg(validationMessages('totalFileSizeExceed'));
          } else {
            setValidationMsg(validationMessages('fileSizeExceed'));
          }
        } else {
          setFileData(file);
          setValidationMsg('');
        }
      } else {
        setValidationMsg(validationMessages('totalFileLength'));
      }
    } else {
      setValidationMsg('');
    }
  };
  /* eslint-enable max-len -- need */
  const onFileChange = (event) => {
    const file = event.target.files[0];
    validateFile(file);
  };

  const onFileUpload = async () => {
    const fileObj = {
      name: fileData.name,
      fileFrom: fieldId,
      type: fileData.type,
      size: fileData.size,
      fileSizeMb: convertFileSizeToMB(fileData.size),
    };
    if (selectFileTypeProps && !uploadedFileType) {
      setSelectFileTypeErrorMsg(selectFileTypeProps.noFileSelectedMsg);
      const fileTypeDropdown = document.querySelector(`#fileSelect-${fieldId}`);
      fileTypeDropdown.focus();
      return;
    }
    if (selectFileTypeProps && uploadedFileType) {
      fileObj.fileType = uploadedFileType;
      fileObj.fileTypeLabel = uploadedFileTypeLabel;
      setUploadedFileType('');
      setUploadedFileTypeLabel('');
      setSelectFileTypeErrorMsg('');
    }
    if (isS3Upload) {
      loggerApiCall('event=s3fileUploadButtonClick status=calledS3FileUploadApi', 'info');
      setIsUploadInProgress(true);
      fileObj.fileId = getUniqueFileId(filledFormData[idGenField], fileData.name);
      const formData = new FormData();
      const payload = {
        head: {
          traceId: uuid(),
          span: 'iForm6513',
        },
        body: {
          ...fileObj,
        },
      };
      formData.append('file', fileData);
      formData.append('data', encryptPayload(payload));
      fetch(`${memberApiUrls}/iForms/${formPageType}/s3/upload?cuid=${contextVal.cuid}`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && data.statusIndicator === 'T') {
            loggerApiCall('status=s3FileUploadApiSuccess', 'info');
            inputRef.current.value = null;
            inputRef.current.files = null;
            setS3FileInfo([...s3FileInfo, fileObj]);
            setAllS3FileIds([...allS3FileIds, fileObj.fileId]);
            setTotalFileSz((prev) => prev + fileData.size);
            if (fileInputButton) fileInputButton.innerHTML = `${chooseFileButton}`;
            setFileData('');
            // setIsLoading(false);
          } else {
            setValidationMsg(validationMessages('fileuploadFailure'));
            loggerApiCall(`status=s3FileUploadApiFailed errorMsg=${data.message}`, 'error');
          }
          setIsUploadInProgress(false);
        });
    } else {
      fileObj.fileId = uuid();
      fileObj.data = fileData;
      setFilesToAttach([...filesToAttach, fileObj]);
      setTotalFileSz((prev) => prev + fileData.size);
      inputRef.current.value = null;
      inputRef.current.files = null;
      if (fileInputButton) fileInputButton.innerHTML = `${chooseFileButton}`;
      setFileData('');
    }
  };

  useEffect(() => {
    let filesForThisTable = [];
    if (isS3Upload && s3FileInfo.length > 0) {
      filesForThisTable = s3FileInfo.filter((fileObj) => fileObj.fileFrom === fieldId);
    } else if (filesToAttach && filesToAttach.length > 0) {
      filesForThisTable = filesToAttach.filter((fileObj) => fileObj.fileFrom === fieldId);
    }
    setUploadResponse([...filesForThisTable]);
  }, [filesToAttach, s3FileInfo, fieldId]);

  useEffect(() => {
    if (entityToEdit && entityToEdit[fieldId] && entityToEdit[fieldId].length > 0) {
      if (isS3Upload) {
        entityToEdit[fieldId].forEach((fileObj) => {
          s3FileInfo.push(fileObj);
        });
        setS3FileInfo([...s3FileInfo]);
      } else {
        entityToEdit[fieldId].forEach((fileObj) => {
          filesToAttach.push(fileObj);
        });
        setFilesToAttach([...filesToAttach]);
      }
    }
  }, [entityToEdit]);

  // total file size and invalid input/size limit validations
  /* eslint-disable max-len -- need */
  const removeUploadDoc = async (resp) => {
    if (isS3Upload) {
      setRemoveFileId(resp.fileId);
      fetch(`${memberApiUrls}/iForms/${formPageType}/s3/delete?cuid=${contextVal.cuid}&docKey=${resp.fileId}`, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && data.statusIndicator === 'T') {
            const updatedS3Files = s3FileInfo.filter((fileObj) => fileObj.fileId !== resp.fileId);
            setS3FileInfo([...updatedS3Files]);
            // update allS3FileIds
            const currFileIds = [...allS3FileIds];
            const updatedFileIds = currFileIds.filter((fileId) => fileId !== resp.fileId);
            setAllS3FileIds([...updatedFileIds]);
            setTotalFileSz((prev) => prev - resp.size);
            // setIsLoading(false);
          } else {
            // message, failed to delete file
          }
          setRemoveFileId(null);
        });
    } else {
      const updatedFilesToAttach = filesToAttach.filter((fileObj) => fileObj.fileId !== resp.fileId);
      setFilesToAttach([...updatedFilesToAttach]);
      setTotalFileSz((prev) => prev - resp.size);
    }
  };
  /* eslint-enable max-len -- need */

  useEffect(() => {
    validateFile();
  }, [uploadResponse]);

  const tableRow = (response) => {
    if (tableDynamicProperties && tableDynamicProperties.valueKeys) {
      return (
        <DataTableRowV2>
          {
            tableDynamicProperties.valueKeys.map((key) => (
              key !== 'removeButton' ? (
                <DataTableCellV2 key={key}>{response ? response[key] : ''}</DataTableCellV2>
              ) : (
                <DataTableCellV2 align="center" key={response.fileId}>
                  <ButtonTertiary
                    id={response.fileId}
                    loading={removeFileId === response.fileId}
                    disabled={removeFileId === response.fileId}
                    onClick={(e) => removeUploadDoc(response, e)}
                    size="sm"
                  >
                    {removeDocButtonLabel}
                  </ButtonTertiary>
                </DataTableCellV2>
              )
            ))
          }
        </DataTableRowV2>
      );
    }
    return (
      <DataTableRowV2>
        <DataTableCellV2>{response ? response.name : ''}</DataTableCellV2>
        <DataTableCellV2>
          {responseMessage.success}
        </DataTableCellV2>
        <DataTableCellV2 align="center">
          <ButtonTertiary
            id={response.fileId}
            loading={removeFileId === response.fileId}
            disabled={removeFileId === response.fileId}
            onClick={(e) => removeUploadDoc(response, e)}
            size="sm"
          >
            {removeDocButtonLabel}
          </ButtonTertiary>
        </DataTableCellV2>
      </DataTableRowV2>
    );
  };
  const checkforSelectionCondition = (option) => {
    if (option.keytoValidate && option.validteFrom === 'filledFormData') {
      if (filledFormData) {
        const value = getVal(filledFormData, option.keytoValidate);
        if (value !== option.valuetoValidateAgainst) {
          return false;
        }
      }
    }
    return true;
  };

  const handleFileTypeChange = (e) => {
    if (e.target.value === '') {
      setSelectFileTypeErrorMsg(selectFileTypeProps.noFileSelectedMsg);
    } else {
      setSelectFileTypeErrorMsg('');
    }
    setUploadedFileType(e.target.value);
    setUploadedFileTypeLabel(e.target?.options[e.target?.selectedIndex]?.text);
  };

  return (
    <>
      {
        selectFileTypeProps && (
          // add a row
          <div className="col-md-12">
            <div className="row">
              <div className={selectFileTypeProps.cssProperties.style}>
                <label
                  className={selectFileTypeProps.fieldLabel.cssProperties.style}
                  htmlFor={`fileSelect-${fieldId}`}
                >
                  {parseHtml(selectFileTypeProps.fieldLabel.label)}
                </label>
                <Select
                  className="select fluid form-control"
                  id={`fileSelect-${fieldId}`}
                  value={uploadedFileType}
                  onChange={handleFileTypeChange}
                >
                  {
                    selectFileTypeProps.fieldOptions.map((option) => (
                      checkforSelectionCondition(option) === true
                        ? (
                          <SelectOption key={option.value} value={option.value}>
                            {option.label}
                          </SelectOption>
                        )
                        : null
                    ))
                  }
                </Select>
                {
                  selectFileTypeErrorMsg
                  && (
                    <div id="alert-error" className="alert dls-color-warning pad-1-t col-md-12">
                      <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
                      <span>{selectFileTypeErrorMsg}</span>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        )
      }

      <div className={inputDls}>
        <div
          id={`Documents_1-iforms-input-container-${fieldId}`}
          className="Documents_1-iforms-input-container iforms-input-container"
        >
          {fieldValidation && fieldValidation.hideFileInput && (
            <ButtonPrimary
              type="button"
              id={`${fieldId}chooseFileButton`}
              onClick={() => inputRef.current.click()}
              className="docs_uploadButton btn-primary btn btn-block margin-1-tb"
            >
              {chooseFileButton}
            </ButtonPrimary>
          )}
          <input
            id={`Documents_1-${fieldId}`}
            className="Documents_1 form-control cursor-wait"
            style={{ padding: '2%', borderColor: '#006fcf', color: '#006fcf' }}
            hidden={hideFileInput}
            type="file"
            // name="Documents_1"
            ref={inputRef}
            onChange={onFileChange}
          />
        </div>
      </div>
      <div className={uploadButtonDls}>
        <div id={`docUpload_container-${fieldId}`} className="docs_uploadButton-container">
          <ButtonSecondary
            type="button"
            id={`Docupload_button-${fieldId}`}
            className="docs_uploadButton btn-secondary btn btn-block margin-1-tb"
            title={uploadButtonLabel}
            loading={isUploadInProgress}
            onClick={onFileUpload}
            disabled={!fileData || isUploadInProgress}
          >
            {uploadButtonLabel}
          </ButtonSecondary>
        </div>
      </div>
      {
        validationMsg && (
          <div className={errorBlockCss}>
            {validationMsg && <p id="validation_error" className={errorCss}>{parseHtml(validationMsg)}</p>}
          </div>
        )
      }
      {fieldLabel && fieldLabel.tableInfo1 && <p className="heading-4 col-md-10 dls-deep-blue text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo1)}</p>}
      {fieldLabel && fieldLabel.tableInfo2 && <p className="label-3 col-md-10 text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo2)}</p>}
      {fieldLabel && fieldLabel.tableInfo3 && <p className="label-3 col-md-10 text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo3)}</p>}
      <div className={tableDls}>
        <DataTableV2
          checkable={null}
          sortable={true}
          id={`dataTable-${fieldId}`}
          key={`dataTable-${fieldId}`}
          className="display-block-sm-down scroll-x-sm-down"
        >
          <DataTableHeadV2>
            {
              tableDynamicProperties && tableDynamicProperties.displayHeaders ? (
                <DataTableRowV2>
                  {
                    tableDynamicProperties.displayHeaders.map((item, index) => (
                      <DataTableHeadCellV2
                        className={tableDynamicProperties.displayHeadersCss
                          ? tableDynamicProperties.displayHeadersCss[index]
                          : null}
                        key={item}
                      >
                        {item}
                      </DataTableHeadCellV2>
                    ))
                  }
                </DataTableRowV2>
              ) : (
                <DataTableRowV2>
                  <DataTableHeadCellV2>
                    {tableDocNameHeader}
                  </DataTableHeadCellV2>
                  <DataTableHeadCellV2>
                    {tableDocStatusHeader}
                  </DataTableHeadCellV2>
                  <DataTableHeadCellV2 align="center">
                    {tableDocRemoveHeader}
                  </DataTableHeadCellV2>
                </DataTableRowV2>
              )
            }
          </DataTableHeadV2>
          <DataTableBodyV2>
            {
              uploadResponse && uploadResponse.length > 0
              && uploadResponse.map((response) => tableRow(response))
            }
          </DataTableBodyV2>
        </DataTableV2>
      </div>
    </>
  );
};

PayloadFileAttachment.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  responseMessage: PropTypes.objectOf(PropTypes.shape),
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  filesToAttach: PropTypes.objectOf(PropTypes.shape),
  setFilesToAttach: PropTypes.func,
  fieldId: PropTypes.string,
  entityToEdit: PropTypes.objectOf(PropTypes.shape),
  s3FileInfo: PropTypes.objectOf(PropTypes.shape),
  setS3FileInfo: PropTypes.func,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  isS3Upload: PropTypes.bool,
  idGenField: PropTypes.string,
  formPageType: PropTypes.string,
  allS3FileIds: PropTypes.objectOf(PropTypes.shape),
  setAllS3FileIds: PropTypes.func,
  disabledButtons: PropTypes.objectOf(PropTypes.shape),
  setDisabledButtons: PropTypes.func,
  buttonsToDisable: PropTypes.arrayOf(PropTypes.shape),
  tableDynamicProperties: PropTypes.objectOf(PropTypes.shape),
  selectFileTypeProps: PropTypes.objectOf(PropTypes.shape),
  loggerApiCall: PropTypes.func,
};

export default PayloadFileAttachment;
